import React from "react";
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import WidthdrawWay, { WidthdrawProps } from "./WidthdrawWay";

type InternalWithdrawWayFieldProps = Pick<
  WidthdrawProps,
  "configs" | "onChange" | "value"
>;

const InternalWithdrawWayField = ({
  configs,
  onChange,
  value,
}: InternalWithdrawWayFieldProps) => {
  return (
    <FromItemPlus
      field={"witdrawWay"}
      className="withdraw-hidden-form-item"
      hidden
      aria-hidden="true"
      style={{ display: "none" }}
    >
      <WidthdrawWay configs={configs} onChange={onChange} value={value} />
    </FromItemPlus>
  );
};

export default InternalWithdrawWayField;
